import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAtom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 216,
	height: 203,
	viewBox: "0 0 216 203",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M197.255 42.8339C197.266 42.8339 197.278 42.8341 197.29 42.8341C197.013 45.8172 197.421 47.8985 200.441 45.0983C202.674 43.0092 202.462 42.8155 200.613 41.096C197.561 37.4115 197.018 39.1239 197.255 42.8339ZM153.128 18.8441C153.858 21.8037 158.327 16.4699 159.728 15.6364C159.286 14.4684 158.039 14.3988 157.118 13.9579C153.011 11.1917 153.933 16.5055 153.128 18.8441ZM190.058 62.8782C190.776 57.1306 184.692 63.3581 182.794 64.603C182.135 66.5032 186.599 66.3777 187.91 67.1755C190.086 67.7564 189.598 63.6765 190.058 62.8782ZM147.922 37.4047C149.301 28.7218 143.726 36.095 140.849 38.6618C138.184 41.0428 146.093 44.8461 147.78 46.4694C150.097 46.5936 147.672 39.1675 147.922 37.4047ZM155.183 60.6553C156.03 62.5306 157.103 71.7177 160.18 70.2522C161.96 69.0047 168.667 68.1065 168.079 65.8259C166.363 65.0439 154.353 56.141 155.183 60.6553ZM171.376 15.1972C176.239 18.6254 181.841 21.0763 186.986 24.1663C187.413 24.5857 188.113 24.2701 188.244 23.8651C187.511 21.0865 186.05 8.08617 182.35 9.34582C178.677 11.3399 174.477 12.3394 171.376 15.1972ZM201.333 69.7649C209.513 70.5667 216.953 66.9934 213.456 58.4191C214.54 56.2392 206.694 44.9716 204.788 47.4346C200.58 51.0917 196.075 54.2428 196.634 60.2893C196.261 66.5836 192.331 69.8959 201.333 69.7649ZM167.997 -7.65457C160.108 -7.56718 157.573 1.87676 155.659 7.95834C155.31 11.0175 160.945 10.5506 162.946 12.0472C168.809 12.7594 174.488 6.20604 180.271 4.64916C182.845 2.75347 176.321 -3.99697 174.491 -5.64463C172.78 -6.98431 170.981 -7.78636 167.997 -7.65457ZM173.655 88.922C182.131 89.0733 185.123 80.988 187.479 74.7003C187.791 73.8561 187.43 73.3716 186.466 73.0223C172.721 67.223 174.652 69.6303 161.515 75.032C159.993 79.0635 169.205 88.605 173.655 88.922ZM124.085 16.5722C123.534 20.921 132.486 36.2011 136.911 36.0305C145.555 27.081 148.617 27.2212 149.346 14.1533C149.827 11.8015 149.177 11.5305 147.286 11.0274C139.903 9.82094 125.879 6.7414 124.085 16.5722ZM141.035 74.3219C142.866 73.3708 156.156 74.0235 154.548 70.2154C152.151 64.6898 152.754 57.3676 147.808 53.2809C144.829 52.0991 137.899 43.4388 135.712 44.8715C125.998 55.6523 119.57 74.0871 141.035 74.3219ZM220.287 14.1895C219.961 -1.17818 200.295 2.67315 190.492 6.5095C189.332 10.0076 193.677 17.1161 194.196 21.2943C195.701 31.4518 197.282 31.9063 205.141 38.278C205.941 38.9005 206.357 38.868 207.095 38.0979C213.191 31.5036 219.586 23.1295 220.287 14.1895ZM152.57 40.0374C150.78 53.902 160.527 54.7897 170.809 60.5311C177.706 65.6763 183.53 56.9394 189.505 54.0154C192.403 50.4831 190.316 44.7519 190.884 40.4308C190.168 37.0973 191.089 32.589 187.711 30.5211C181.385 26.4475 175.26 22.1849 168.407 18.9835C163.372 16.9778 158.508 24.6075 154.129 26.6248C150.39 29.9142 152.685 35.7268 152.57 40.0374ZM138.257 6.32991C141.797 6.49621 145.284 6.92891 148.735 7.68769C150.325 8.03696 150.602 7.90942 151.125 6.3186C154.006 -2.02068 160.924 -17.5558 172.202 -12.6666C178.395 -10.2468 182.901 -5.0906 186.294 0.345895C187.115 1.68586 187.397 1.74355 189.005 1.24637C199.789 -1.69205 218.465 -5.78179 223.116 7.54911C226.932 20.2406 217.611 32.2779 210.063 41.9399C209.02 43.2756 210.948 44.3735 211.491 45.4991C213.959 48.6332 215.079 52.6282 217.917 55.4108C222.607 64.4444 218.579 75.5213 206.798 75.7979C202.971 77.0026 195.094 73.7684 193.039 75.8205C190.422 82.804 186.041 90.8782 178.011 92.8076C169.073 94.4058 162.908 86.6672 159.023 79.997C158.095 76.8428 156.368 76.3199 153.32 77.4232C145.442 79.0329 136.469 80.3104 129.25 75.9353C117.374 67.6133 125.629 51.6109 132.084 42.3797C134.246 39.3075 128.616 36.5249 127.345 33.7955C116.896 21.1125 118.286 5.27333 138.257 6.32991Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M134.212 91.0986C142.244 93.3789 131.003 104.524 126.348 105.026C120.301 104.684 132.054 92.0942 134.212 91.0986Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M172.955 123.812C170.694 136.868 161.162 116.106 168.498 112.792C173.356 111.775 172.23 120.581 172.955 123.812Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1357 13.0563C38.9218 12.9559 9.81668 24.83 9.16797 16.0811C10.2154 12.4382 16.0148 13.452 19.136 13.1968C19.136 13.15 19.136 13.1031 19.1357 13.0563Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M109.72 8.49332C107.192 7.45379 93.3754 8.57771 95.6503 3.67516C98.2171 -1.85949 121.408 8.14491 109.72 8.49332Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M199.964 132.242C199.746 135.993 195.579 132.189 194.868 130.571C193.511 127.55 191.382 120.971 195.138 119.194C201.058 120.587 198.757 127.818 199.964 132.242Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.3925 37.0444C14.6357 39.6608 15.2519 39.9547 12.366 41.0361C-6.5788 49.7272 -2.03902 34.8972 14.3925 37.0444Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M76.7196 62.5604C77.3578 66.1014 72.416 68.9574 69.1055 68.1481C65.2404 66.5899 68.6905 60.7974 72.0298 60.4093C74.3355 59.8386 78.2412 58.9599 76.7196 62.5604Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M184.227 152.356C184.971 153.721 183.59 154.097 183.7 155.077C185.325 155.948 184.641 161.581 182.545 160.311C174.647 155.936 181.674 137.275 184.227 152.356Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.7688 42.0722C89.3315 42.5475 88.1244 38.6062 90.452 37.7805C93.6795 37.1189 101.29 35.1391 103.575 37.4095C101.761 40.9249 95.8323 41.5096 91.7688 42.0722Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M85.336 25.7173C80.3641 26.3484 74.6698 22.2556 82.1767 20.2128C87.3268 18.7254 96.0797 26.3311 85.336 25.7173Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M209.908 92.8469C209.441 90.3733 214.159 89.5236 215.009 91.3898C215.789 94.5028 218.346 98.0993 217.702 101.184C213.859 101.105 210.848 96.1615 209.908 92.8469Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M220.782 199.515C219.432 207.33 213.644 200.179 214.293 195.768C216.218 189.598 221.223 195.131 220.782 199.515Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M136.597 134.299C135.95 131.431 140.245 123.251 143.341 125.991C144.238 130.508 140.222 133.844 138.189 137.515C136.558 138.46 136.991 135.186 136.597 134.299Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M216.814 140.248C216.268 144.497 208.771 136.965 208.371 134.932C207.934 133.801 208.083 133.127 209.151 132.555C213.541 130.492 216.217 137.054 216.814 140.248Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.523 174.273C141.101 170.833 144.411 164.156 147.578 167.794C148.533 171.13 142.577 182.744 141.523 174.273Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M206.655 176.34C204.453 179.449 201.484 174.229 200.658 172.263C199.055 169.806 202.105 163.669 204.672 167.473C205.433 170.452 205.948 173.315 206.655 176.34Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M55.8006 9.20732C51.2866 9.43349 50.5877 3.60531 55.0363 3.21045C57.1745 3.413 62.5738 3.91682 61.5774 6.93204C60.3445 9.15014 58.05 8.89923 55.8006 9.20732Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.5041 46.9146C27.086 51.5136 21.5366 53.4024 17.2676 53.3945C13.9757 53.5379 13.6155 49.3413 16.9617 49.1166C20.6502 48.6891 23.964 49.2311 27.5041 46.9146Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.8547 50.2534C49.3085 50.209 47.8342 50.3573 47.6938 49.3554C44.6629 44.8134 53.695 44.3497 56.5506 45.5762C60.0656 49.0363 52.7628 50.4783 49.8547 50.2534Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M109.035 86.2081C108.889 83.627 114.169 79.4732 115.549 83.2505C116.032 84.9657 117.368 86.7898 115.48 87.9026C113.071 90.0594 108.812 90.2594 109.035 86.2081Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M164.917 163.57C164.484 174.127 163.2 173.589 160.301 163.694C158.7 158.061 165.994 157.646 164.917 163.57Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M193.064 193.728C193.71 196.591 192.979 198.232 189.306 198.918C186.928 198.91 188.161 195.245 187.576 193.715C187.47 189.673 194.333 188.604 193.064 193.728Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.4212 31.0659C42.3934 29.8972 51.5762 24.1125 55.4637 27.6163C58.1998 30.2221 53.0223 30.3557 51.4212 31.0659Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M154.845 94.3153C154.319 95.6252 154.39 99.7047 152.376 99.4958C149.322 98.9313 149.248 93.7564 151.378 92.1258C153.056 91.3552 155.107 92.0209 154.845 94.3153Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M110.625 62.0429C107.823 60.8271 109.986 58.1077 111.678 56.9138C112.965 55.586 117.966 56.4123 116.412 58.7524C114.672 60.1324 112.633 60.8845 110.625 62.0429Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.5373 17.0077C37.6801 13.356 41.9035 15.1289 43.8774 15.4398C48.1025 18.0969 37.1025 22.2797 38.5373 17.0077Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M157.936 193.823C158.231 199.309 152.859 193.187 154.403 190.595C155.828 187.121 158.793 191.562 157.936 193.823Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M91.4332 75.6991C90.5625 75.6004 89.7261 75.9311 89.2031 75.51C89.7863 75.197 90.6504 75.0676 91.4332 75.6991Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M175.929 37.9557C175.957 42.5235 172.473 45.0161 168.71 45.8961C163.829 46.6483 161.581 39.8665 162.504 35.9522C165.075 26.7381 175.356 29.9297 175.929 37.9557Z",
			fill: "#79C912",
			fillOpacity: .1
		})
	]
});
export default SvgAtom;
